// Marketplace referral fee: either a % of the item price (default) or a fixed ₹ amount.
// referral_fee_type === "fixed" → use referral_fee_fixed; otherwise referral_fee_pct.

export const isFixedReferral = (mp) => (mp?.referral_fee_type || "pct") === "fixed";

export function referralAmount(mp) {
  if (!mp) return 0;
  if (isFixedReferral(mp)) return Number(mp.referral_fee_fixed) || 0;
  return (Number(mp.item_price) || 0) * ((Number(mp.referral_fee_pct) || 0) / 100);
}

export function referralLabel(mp) {
  return isFixedReferral(mp)
    ? `Referral Fee (₹${Number(mp?.referral_fee_fixed) || 0} fixed)`
    : `Referral Fee (${mp?.referral_fee_pct || 0}%)`;
}
